import {
  FileGifOutlined,
  FileImageOutlined,
  FileJpgOutlined,
  FileMarkdownOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileTextOutlined,
  FileZipOutlined,
  FolderOutlined,
} from '@ant-design/icons';
import { ExcelFileTwoTable, WordFileTwoTable } from '@marine/icons';
import { FC } from 'react';
import styles from '../NameColumn.module.scss';

interface FileIconProps {
  fileType: string | undefined;
}

const TableFileIcon: FC<FileIconProps> = ({ fileType }) => {
  const fileIcons = [
    {
      icon: <WordFileTwoTable />,
      ext: 'docx',
    },
    {
      icon: <ExcelFileTwoTable />,
      ext: 'xlsx',
    },
    {
      icon: <FileGifOutlined className={styles.tableIconStyles} />,
      ext: 'gif',
    },
    {
      icon: <FileImageOutlined className={styles.tableIconStyles} />,
      ext: 'png',
    },
    {
      icon: <FileJpgOutlined className={styles.tableIconStyles} />,
      ext: 'jpg',
    },
    {
      icon: <FileJpgOutlined className={styles.tableIconStyles} />,
      ext: 'jpeg',
    },
    {
      icon: <FileMarkdownOutlined className={styles.tableIconStyles} />,
      ext: 'md',
    },
    {
      icon: <FilePdfOutlined className={styles.tableIconStyles} />,
      ext: 'pdf',
    },
    {
      icon: <FilePptOutlined className={styles.tableIconStyles} />,
      ext: 'pptx',
    },
    {
      icon: <FileTextOutlined className={styles.tableIconStyles} />,
      ext: 'txt',
    },
    {
      icon: <FileZipOutlined className={styles.tableIconStyles} />,
      ext: 'zip',
    },
    {
      icon: <FileZipOutlined className={styles.tableIconStyles} />,
      ext: 'rar',
    },
    {
      icon: <FolderOutlined className={styles.tableIconStyles} />,
      ext: 'folder',
    },
  ];

  const fileTableIcon = fileIcons?.find((icon) => icon.ext === fileType);

  if (fileTableIcon) {
    return fileTableIcon.icon;
  }

  return <FileOutlined className={styles.tableIconStyles} />;
};

export default TableFileIcon;
